module.exports = __webpack_public_path__ + "assets/img/teacher (16).f963b78c.png";